import type { ReactNode } from 'react';

interface Props {
  onClick: () => void;
  children: ReactNode;
  hint?: string;
  tone?: 'default' | 'danger';
}

/** Wiersz akcji w arkuszu — cały wiersz jest celem dotyku. */
export function SheetAction({ onClick, children, hint, tone = 'default' }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex min-h-12 w-full flex-col items-start justify-center rounded-xl px-3 py-2 text-left active:bg-stone-100 dark:active:bg-stone-800 ${
        tone === 'danger' ? 'text-red-600 dark:text-red-400' : ''
      }`}
    >
      <span className="font-medium">{children}</span>
      {hint && <span className="text-sm text-stone-500">{hint}</span>}
    </button>
  );
}
